import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
function PassValidity(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: props.fill
  }, props), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-432.000000, -70.000000)",
    fill: "#36424A"
  }, React.createElement("g", {
    transform: "translate(432.000000, 70.000000)"
  }, React.createElement("path", {
    d: "M35,9 C35.5522847,9 36,9.44771525 36,10 L36,30.1304348 C36,33.3721957 32.4962609,36 28.173913,36 L7.82608696,36 C3.50373913,36 0,33.3721957 0,30.1304348 L0,10 C-6.76353751e-17,9.44771525 0.44771525,9 1,9 L35,9 Z M23.2488416,14.8145647 C23.0752733,14.7067385 22.8483402,14.7470652 22.7225473,14.9080887 L17.0151748,22.2139132 C16.9503396,22.2969066 16.8322527,22.3154008 16.7451483,22.2562033 L11.8625859,18.9379402 C11.6812548,18.8147048 11.4345132,18.8604036 11.3093443,19.0404054 L9.23167339,22.0282458 C9.10492221,22.2161616 9.15329269,22.4647657 9.33646101,22.588266 L17.6823435,28.2154345 C17.8599525,28.3351864 18.1003746,28.293765 18.2276701,28.1214824 L26.2886286,17.2117279 L26.3066925,17.1851026 C26.4232678,16.9974509 26.365649,16.7508262 26.1779973,16.6342509 Z"
  }), React.createElement("path", {
    d: "M33,0.8 C33.6075132,0.8 34.1575132,1.04624339 34.5556349,1.44436508 C34.9537566,1.84248678 35.2,2.39248678 35.2,3 L35.2,3.7 L0.8,3.7 L0.8,3 C0.8,2.39248678 1.04624339,1.84248678 1.44436508,1.44436508 C1.84248678,1.04624339 2.39248678,0.8 3,0.8 Z",
    stroke: "#36424A",
    strokeWidth: "1.6"
  })))));
}
const MemoPassValidity = React.memo(PassValidity);
export default MemoPassValidity;